import styled from 'styled-components';

import FAVORITE from '../../../../assets/imgs/heart-icon-active.svg';
import { Icon } from '../../../../GlobalComponents/Icon';

export type FavoritesProps = {
	name: string;
	icon: string;
	selectProduct: any;
	isFavorite: boolean | undefined;
};

export const Product: React.FC<FavoritesProps> = ({
	name,
	icon,
	selectProduct,
	isFavorite
}) => {
	return (
		<ProductContainer onClick={selectProduct}>
			<ProductImageContainer>
				<ProductImage src={icon} alt={name}></ProductImage>
				{isFavorite && (
					<FavoriteIcon title="Favorite Item">
						<Icon
							$url={FAVORITE}
							alt="favorite"
							$width={24}
							$height={24}
						/>
					</FavoriteIcon>
				)}
			</ProductImageContainer>
			<ProductName>{name}</ProductName>
		</ProductContainer>
	);
};

const ProductImageContainer = styled.div`
	position: relative;
	width: 100%;
	height: 80%;

	@media (max-width: 992px) {
		height: 75%;
	}
`;

const ProductContainer = styled.div`
	min-height: 160px;
	cursor: pointer;
	background: #fdfdfd;
	border-radius: 4px;
	transition: 0.3s;
	box-shadow: 0px 1px 2px rgba(17, 11, 11, 0.25);
	&:hover {
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
	}
`;

const ProductImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

const ProductName = styled.div`
	height: 20%;
	font-weight: 500;
	font-size: 20px;
	line-height: 120%;
	padding: 16px;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	@media (max-width: 992px) {
		font-size: 14px;
		height: 25%;
	}
	@media (max-width: 480px) {
		font-size: 14px;
	}
`;

const FavoriteIcon = styled.div`
	position: absolute;
	top: 10px;
	right: 10px;
`;
